module.exports = __webpack_public_path__ + "img/productBanner2.b756ec46.png";